const SYSTEM_COLOURS = {
  WHITE: '#ffffff',
  BLACK: '#212121',
  GREY: '#F7F7F7'
};

export default SYSTEM_COLOURS;
